// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown'
import CartDropdown from './CartDropdown'
import UserDropdown from './UserDropdown'
import NavbarSearch from './NavbarSearch'
import NotificationDropdown from './NotificationDropdown'
// import { useDate } from './../../../../views/dailyLog/context/DateContext'
import Cookies from 'js-cookie'
const getUserData = JSON.parse(localStorage.getItem("userData")) || {}
const expiry_date = getUserData.expiry_date
const dateFromCookie = Cookies.get('selectedDate')
// ** Third Party Components
import { Sun, Moon } from 'react-feather'
import { useNavigate } from "react-router-dom"

// ** Reactstrap Imports
import { NavItem, NavLink } from 'reactstrap'

const NavbarUser = props => {
  // const { selectedDate } = useDate()
  const currentD = new Date(dateFromCookie)
// const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  
  // Function to format the date as "dd/mm/yy (Day)"
  const formattedDate = ` ${currentD.getDate()}-${currentD.getMonth() + 1}-${currentD.getFullYear()} `
 
  const navigate = useNavigate()
  // ** Props
  const { skin, setSkin } = props
  //const formattedDate = ` ${selectedDate.getDate()}-${selectedDate.getMonth() + 1}-${selectedDate.getFullYear() % 100} `

  const handleDayStartPage = () => {
    navigate(`/dailyLog/dayStart`)
  }

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }

  return (
    <ul className='nav navbar-nav align-items-center ms-auto'>
<p  className='me-2 '  onClick={handleDayStartPage} >Expiry Date : {expiry_date || ''}</p>
<p className='me-2 '  onClick={handleDayStartPage} >Reading Date : {formattedDate || ''}</p>
   
      {/* <IntlDropdown /> */}
      {/* <NavItem className='d-none d-lg-block'>
        <NavLink className='nav-link-style'>
          <ThemeToggler />
        </NavLink>
      </NavItem> */}
      {/* <NavbarSearch />
      <CartDropdown />
      <NotificationDropdown /> */}
      <UserDropdown />
    </ul>
  )
}
export default NavbarUser